import { render } from "./LoginRedirect.vue?vue&type=template&id=6f261810"
import script from "./LoginRedirect.vue?vue&type=script&lang=js"
export * from "./LoginRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__